import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button } from '@/shared/components/Button';
import { fetchAuthBlob } from '@/lib/api-client';
/**
 * Downloads classes as a standard .ics file (with 30-min reminders), importable
 * into Google Calendar, Apple Calendar and Outlook.
 */
export function CalendarSyncButton({ endpoint, fileName = 'academia-apolo.ics' }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    async function handleDownload() {
        setError('');
        setLoading(true);
        try {
            const { blob } = await fetchAuthBlob(endpoint);
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        }
        catch {
            setError('No se pudo generar el calendario.');
        }
        finally {
            setLoading(false);
        }
    }
    return (_jsxs("div", { className: "flex flex-col items-end gap-1", children: [_jsx(Button, { variant: "secondary", size: "sm", loading: loading, onClick: handleDownload, children: "Sincronizar calendario" }), error && _jsx("p", { role: "alert", className: "text-xs text-red-600 dark:text-red-400", children: error })] }));
}
//# sourceMappingURL=CalendarSyncButton.js.map